import {
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
  font_sm,
  font_xs,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const staticPillClassName = 'BulkInvitePrepareCsvCard-staticPill'

export const root = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(5)};
  background: ${base_colorSurfaceSecondary};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${cornerRadius};
  padding: ${spacing(5)};

  .${staticPillClassName} {
    pointer-events: none;
  }
`

export const title = css`
  ${font_lg};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
  margin: 0;
`

export const body = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
  margin: 0;
`

export const bodyEmphasis = css`
  font-family: ${font_family_weight_medium};
  font-weight: normal;
  color: ${text_colorTextPrimary};
`

export const sectionLabel = css`
  ${font_xs};
  font-family: ${font_family_weight_medium};
  letter-spacing: 0.06em;
  color: ${text_colorTextSecondary};
  margin: 0;
`

export const fieldList = css`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
`

export const fieldRow = css`
  display: flex;
  align-items: flex-start;
  gap: ${spacing(2)};
`

export const fieldIcon = css`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-top: 1px;
`

export const fieldBody = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
  min-width: 0;
`

export const fieldHeader = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
  flex-wrap: wrap;
`

export const fieldName = css`
  ${font_md};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
`

export const fieldHint = css`
  ${font_sm};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

export const statRow = css`
  display: flex;
  align-items: stretch;
  gap: ${spacing(3)};
  border-top: 1px solid ${base_colorContentBorder};
  padding-top: ${spacing(4)};
`

export const stat = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
  flex: 1 1 0;
  min-width: 0;
`

export const statValue = css`
  ${font_md};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
`

export const statLabel = css`
  ${font_xs};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`

export const templateRow = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing(1)};
`

export const templatePrompt = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`
